import { forwardRef } from 'react'
import { cn } from '../../utils/helpers'

export const Input = forwardRef(function Input(
  { label, error, className = '', required, ...props },
  ref
) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-[#1a1a1a] mb-1.5">
          {label}
          {required && <span className="text-danger ml-0.5">*</span>}
        </label>
      )}
      <input
        ref={ref}
        className={cn(
          'w-full px-3.5 py-2.5 bg-white border border-[#ececec] rounded-[6px] text-sm text-[#1a1a1a] placeholder:text-[#8a8a8a]',
          'transition-all duration-200',
          'hover:border-[#ececec]',
          'focus:border-accent focus:ring-2 focus:ring-accent/20 focus:outline-none',
          error && 'border-danger focus:border-danger focus:ring-danger/20',
          className
        )}
        required={required}
        {...props}
      />
      {error && <p className="mt-1.5 text-sm text-danger">{error}</p>}
    </div>
  )
})

export function Select({ label, error, children, className = '', required, ...props }) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-[#1a1a1a] mb-1.5">
          {label}
          {required && <span className="text-danger ml-0.5">*</span>}
        </label>
      )}
      <select
        className={cn(
          'w-full px-3.5 py-2.5 bg-white border border-[#ececec] rounded-[6px] text-sm text-[#1a1a1a]',
          'transition-all duration-200',
          'hover:border-[#ececec]',
          'focus:border-accent focus:ring-2 focus:ring-accent/20 focus:outline-none',
          'cursor-pointer appearance-none',
          'bg-[url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%20stroke%3D%22%236c757d%22%20stroke-width%3D%222%22%3E%3Cpath%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20d%3D%22M19%209l-7%207-7-7%22%2F%3E%3C%2Fsvg%3E")]',
          'bg-[length:20px] bg-[right_12px_center] bg-no-repeat pr-10',
          error && 'border-danger focus:border-danger focus:ring-danger/20',
          className
        )}
        required={required}
        {...props}
      >
        {children}
      </select>
      {error && <p className="mt-1.5 text-sm text-danger">{error}</p>}
    </div>
  )
}

export function Textarea({ label, error, className = '', required, ...props }) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-[#1a1a1a] mb-1.5">
          {label}
          {required && <span className="text-danger ml-0.5">*</span>}
        </label>
      )}
      <textarea
        className={cn(
          'w-full px-3.5 py-2.5 bg-white border border-[#ececec] rounded-[6px] text-sm text-[#1a1a1a] placeholder:text-[#8a8a8a]',
          'transition-all duration-200 resize-none',
          'hover:border-[#ececec]',
          'focus:border-accent focus:ring-2 focus:ring-accent/20 focus:outline-none',
          error && 'border-danger focus:border-danger focus:ring-danger/20',
          className
        )}
        required={required}
        {...props}
      />
      {error && <p className="mt-1.5 text-sm text-danger">{error}</p>}
    </div>
  )
}

export function Checkbox({ label, className = '', ...props }) {
  return (
    <label className={cn('flex items-center gap-2.5 cursor-pointer', className)}>
      <input
        type="checkbox"
        className={cn(
          'w-4 h-4 rounded border-[#ececec] text-accent',
          'focus:ring-2 focus:ring-accent/20 focus:ring-offset-0',
          'cursor-pointer transition-colors'
        )}
        {...props}
      />
      {label && <span className="text-sm text-[#1a1a1a]">{label}</span>}
    </label>
  )
}
